import { render, staticRenderFns } from "./cascader-radio-widget.vue?vue&type=template&id=fc34130c&scoped=true"
import script from "./cascader-radio-widget.vue?vue&type=script&lang=js"
export * from "./cascader-radio-widget.vue?vue&type=script&lang=js"
import style0 from "./cascader-radio-widget.vue?vue&type=style&index=0&id=fc34130c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc34130c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fc34130c')) {
      api.createRecord('fc34130c', component.options)
    } else {
      api.reload('fc34130c', component.options)
    }
    module.hot.accept("./cascader-radio-widget.vue?vue&type=template&id=fc34130c&scoped=true", function () {
      api.rerender('fc34130c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form-designer/form-widget/field-widget/cascader-radio-widget.vue"
export default component.exports